var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('HeadTitle',{attrs:{"title":"用户服务"}}),_c('div',{staticClass:"body"},[_c('div',{staticClass:"item",on:{"click":function($event){return _vm.$router.push({
          name: 'WorkerSubmit',
          query: {
            organizationId: _vm.organizationId,
            category: _vm.category
          }
        })}}},[_c('div',{staticClass:"title"},[_vm._v("新用户注册")]),_c('img',{attrs:{"src":require("@/assets/images/icon-server-user.png"),"alt":""}})]),_c('div',{staticClass:"item",on:{"click":function($event){return _vm.$router.push({
          name: 'AuthUser',
          query: {
            organizationId: _vm.organizationId,
            category: _vm.category
          }
        })}}},[_c('div',{staticClass:"title"},[_vm._v("手机号变更")]),_c('img',{attrs:{"src":require("@/assets/images/icon-server-phone.png"),"alt":""}})])]),_c('van-dialog',{staticClass:"submit-dialog",attrs:{"show-confirm-button":false,"close-on-click-overlay":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("选择身份")]},proxy:true}]),model:{value:(_vm.isShowSubmitDialog),callback:function ($$v) {_vm.isShowSubmitDialog=$$v},expression:"isShowSubmitDialog"}},[[_c('div',{staticClass:"content"},[_c('div',{staticClass:"item",on:{"click":function($event){return _vm.$router.push({
              name: 'StudentSubmit',
              query: {
                organizationId: _vm.organizationId
              }
            })}}},[_c('div',{staticClass:"title"},[_vm._v("我是学生")]),_c('img',{attrs:{"src":require("@/assets/images/icon-submit-student.png"),"alt":""}})]),_c('div',{staticClass:"item",on:{"click":function($event){return _vm.$router.push({
              name: 'WorkerSubmit',
              query: {
                organizationId: _vm.organizationId,
                category: _vm.category
              }
            })}}},[_c('div',{staticClass:"title"},[_vm._v("我是职工")]),_c('img',{attrs:{"src":require("@/assets/images/icon-submit-teacher.png"),"alt":""}})])])]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }